<template>
    <div style="width: 100%; height: 30px;line-height: 30px; background-color: #52b7e3; color: #fff; text-align: center;border-radius: 0px 0 0 0px;overflow: hidden;"
         @click="handleClick" >
        {{index}}
    </div>
</template>
<script>
    export default {
        props:['index'],
        data() {
            return {

            }
        },
        methods: {
            handleClick() {
                this.$emit("click-item");
            },
        }

    };
</script>